import { getMobileBreakpoint, isMobileBreakpoint } from "../utility/UtilityFunctions";

class Accordion {
    constructor(el) {
        this.options = el.dataset.moduleOptions ? JSON.parse(el.dataset.moduleOptions) : {};

        const buttons = el.querySelectorAll('button[aria-controls]')
        this.init(buttons);

        if(this.options.mobileOnly) {
            const breakpoint = window.matchMedia(`(max-width: ${getMobileBreakpoint()}px)`);
            breakpoint.addEventListener("change", () => this.update(buttons));

            // set inital state
            this.update(buttons)
        }
    }

    init(buttons) {
        buttons.forEach((button) => {
            const panelId = button && button.getAttribute('aria-controls');
            const panel = panelId ? document.getElementById(panelId) : null;
            button.addEventListener('click', () => this.toggleAccordion(button, panel));
        });
    }

    update(buttons) {
        buttons.forEach((button) => {
            const panelId = button && button.getAttribute('aria-controls');
            const panel = panelId ? document.getElementById(panelId) : null;
            this.setAccordionExpanded(button, panel, !isMobileBreakpoint());
        });
    }

    setAccordionExpanded(button, panel, shouldBeExpanded) {

        const expanded = shouldBeExpanded ? "true" : "false";
        if (button.getAttribute('aria-expanded') !== expanded) {
            button.setAttribute('aria-expanded', shouldBeExpanded);
        }

        panel.hidden = !shouldBeExpanded;
    }

    toggleAccordion(button, panel) {
        if (!this.allowToggle()) return; // desktop stays expanded and non-interactive
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        this.setAccordionExpanded(button, panel, !isExpanded);
    }

    allowToggle() {
        let allow = true;

        if(this.options.mobileOnly && !isMobileBreakpoint()) {
            allow = false
        }

        return allow
    }
}

export default Accordion
